<template>
    <ListTile class="profile-card__header background-transparent">

        <template v-slot:icon>
            <ProfilePicUser class="profile-pic__user-profile">
                <template v-slot:verification-status>
                    <v-tooltip location="bottom">
                        <template #activator="{ props }">
                            <v-icon :color="user.verification_status === 'verified' ? 'success' : ''"
                                :class="{ 'profile-unverified': user.verification_status !== 'verified' }"
                                v-bind="props">
                                mdi-check-decagram-outline
                            </v-icon>
                        </template>
                        <span>{{ user.verification_status === 'verified' ? 'Verified' : 'Unverified' }}</span>
                    </v-tooltip>
                </template>
            </ProfilePicUser>
        </template>



        <template v-slot:details>
            <TileDetails>
                <template v-slot:name>
                    <span class="profile-card__header__title">
                        {{ user.nick_name }}
                    </span>
                </template>
                <template v-slot:description>
                    <span class="profile-card__header__description">
                        {{ user.email }}
                    </span>
                </template>
            </TileDetails>
        </template>


        <template v-slot:append-right>
            <slot name="append-right">
                <button class="button__profile--edit rounded-circle" @click="$router.push('/edit-profile')">
                    <EditIcon></EditIcon>
                </button>
            </slot>
        </template>



    </ListTile>
</template>



<script setup>

import { computed } from "vue";
import { useUserStore } from "@/store/UserStore";

import EditIcon from "@/icons/EditIcon.vue";
import ProfilePicUser from "./Profile-Pic-User.vue";
import ListTile from '@/components/Tiles/List-Tile.vue';
import TileDetails from "@/components/Common/Tile-Details.vue";

const userStore = useUserStore();
const user = computed(() => userStore.user);

</script>